module.exports = __webpack_public_path__ + "static/media/luggers-moving-home.0f4872a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/luggers-moving-home.png
// module id = 1203
// module chunks = 27